import getColor from "@insite/mobius/utilities/getColor";
import { savedOrderListHeaderStyles as styles } from "@solveindustrial/Overrides/Widgets/SavedOrderList/SavedOrderListHeader";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.container = {
    ...styles.container,
    gap: 0,
    css: css`
        ${styles.container?.css}
        padding: 0 0 100px;
        position: relative;
    `,
};

styles.titleGridItem = {
    ...styles.titleGridItem,
    width: [12, 12, 8, 8, 8],
};

styles.toggleFilterGridItem = {
    ...styles.toggleFilterGridItem,
    width: 4,
    css: css`
        ${styles.toggleFilterGridItem?.css}
        position: absolute;
        right: 0;
        top: 70%;
    `,
};

styles.clearTypography = {
    ...styles.clearTypography,
    css: css`
        ${styles.clearTypography?.css}
        display: none;
    `,
};

styles.toggleFilterButton = {
    ...styles.toggleFilterButton,
    css: css`
        ${styles.toggleFilterButton?.css}
        background-color: transparent;
        border: 0;
        width: auto;
        padding: 0 !important;

        &:hover,
        &:focus,
        &:active {
            background-color: transparent !important;
            border: 0 !important;
            outline: none !important;
        }

        svg {
            stroke: ${getColor(colorStrings.primaryMain)};
        }
    `,
};
